module.exports = __webpack_public_path__ + "static/media/error-exclamation.13522d96.png";